module.exports = __webpack_public_path__ + "static/media/virtuallab.6c698d3f.png";